import React from 'react';

const BadgeLoser: React.FC = ({ children }) => {
  return (
    <span className="nes-badge is-icon">
      <span />
      <span className="is-error">{children}</span>
    </span>
  );
};

export default BadgeLoser;
